export default {
  alert: {
    okCallback: null,
    shown: false,
    text: '',
    show(message, okCallback = null) {
      if (message) {
        this.text = message;
      }
      this.okCallback = okCallback;
      this.shown = true;
    },
    ok() {
      if (typeof this.okCallback === 'function') {
        this.okCallback();
      }
    },
  },

  confirm: {
    SURVEY_SUBMIT: 'SURVEY_SUBMIT',

    shown: false,
    okButtonTitle: 'OK',
    isOkOnly: false,
    okCallback: null,
    cancelCallback: null,
    isHtml: false,
    show(
      message,
      okButtonTitle,
      okCallback,
      cancelCallback,
      isHtml = false,
      isOkOnly = false
    ) {
      this.text = message;
      this.okButtonTitle = okButtonTitle;
      this.okCallback = okCallback;
      this.cancelCallback = cancelCallback;
      this.isHtml = isHtml;
      this.isOkOnly = isOkOnly;
      this.shown = true;
    },
    ok() {
      if (this.okCallback) {
        this.okCallback();
      }
    },
    cancel() {
      if (this.cancelCallback) {
        this.cancelCallback();
      }
    },
  },
};
